<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-navbar
      class="app-header d-print-none"
      :class="[navbarTypeClass, 'header-' + navbarColorScheme]"
    >
      <b-nav>
        <b-nav-item id="v-step-0">
          <a
            v-if="!this.sidebarClose"
            class="d-md-down-none px-1"
            href="#"
            @click="toggleSidebarMethod"
          >
            <!-- <i class="icon d-flex">
            <svg width="20px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
            </svg>
            </i> -->
            <i class="icon">
              <svg
                class="icon-20"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.25 12.2744L19.25 12.2744"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </i>
          </a>
          <a
            v-else
            class="d-md-down-none px-1"
            href="#"
            @click="toggleSidebarMethod"
          >
            <i class="icon d-flex">
              <svg width="20px" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                />
              </svg>
            </i>
            <!-- <i class="icon"><svg class="icon-20" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.25 12.2744L19.25 12.2744" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></i> -->
          </a>
          <a class="fs-lg d-md-none" href="#" @click="switchSidebarMethod">
            <!-- <img
              :src="Menu"
              alt="menu"
          /> -->
            <i class="icon">
              <svg
                class="icon-20"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.25 12.2744L19.25 12.2744"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </i>
          </a>
        </b-nav-item>
        <!-- <b-nav-item class="d-md-down-none">
        <a href="#" class="px-1">
          <img
            :src="Exchange"
            alt="exchange"
          />
        </a>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <a href="#" class="px-2">
            <img
                :src="Cross"
                alt="cross"
            />
          </a>
        </b-nav-item> -->
      </b-nav>
      <!-- <b-nav>
      <b-form class="d-md-down-none ms-5 my-auto" inline>
        <b-form-group class="mb-0">
          <b-input-group class="input-group-no-border search-input">
              <template v-slot:prepend>
                <div class="headerSvgFlipColor">
                  <b-input-group-text>
                    <div>
                      <img
                          :src="Search"
                          alt="search"
                      />
                    </div>
                  </b-input-group-text>
                </div>
              </template>
            <b-form-input id="search-input" placeholder="Search Dashboard" />
          </b-input-group>
        </b-form-group>
      </b-form>
    </b-nav> -->
      <!-- <a  class="navbarBrand d-md-none">
      <i class="fa fa-circle text-primary me-1" />
      <i class="fa fa-circle text-danger" />
      sing
      <i class="fa fa-circle text-danger me-1" />
      <i class="fa fa-circle text-primary" />
    </a> -->
      <b-nav class="ms-auto">
        <b-nav-item-dropdown
          @hide="dropdown = false"
          @show="dropdown = true"
          id="v-step-1"
          right
        >
          <template slot="button-content">
            <span style="margin-right: 10px"
              >Hi {{ user.name || user.email || 'Philip smith' }}</span
            >
            <span class="avatar rounded-circle thumb-sm float-start me-2">
              <img
                v-if="user.avatar || user.email === 'admin@flatlogic.com'"
                class="rounded-circle"
                :src="user.avatar || avatarImage"
                :alt="user.name"
              />
              <span v-else>{{ firstUserLetter }}</span>
            </span>
          </template>
          <b-dropdown-item-button @click="logoutUser">
            <img :src="Cancel" class="px-2 me-2" alt="cancel" />
            Log Out
          </b-dropdown-item-button>
          <!-- <Notifications /> -->
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          v-if="user.role == 'pemohon'"
          @hide="dropdown = false"
          @show="dropdown = true"
          id="v-step-1"
          right
        >
          <template slot="button-content">
            <i class="fa fa-bell-o" />
          </template>
          <Notifications />
        </b-nav-item-dropdown>
      </b-nav>
    </b-navbar>
    <!-- <FloatingChat /> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import avatarImage from '@/assets/people/a7.png'
import Menu from '@/assets/sidebar/Fill/Menu.svg'
import Exchange from '@/assets/sidebar/Fill/Exchange.svg'
import Cross from '@/assets/sidebar/Fill/Cross.svg'
import Search from '@/assets/sidebar/Fill/Search.svg'
import CaretDown from '@/assets/sidebar/Fill/Caret down.svg'
import Settings from '@/assets/sidebar/Outline/Settings-alt.svg'
import User from '@/assets/sidebar/Outline/User.svg'
import Document from '@/assets/sidebar/Outline/Document.svg'
import Envelope from '@/assets/sidebar/Outline/Envelope.svg'
import Cancel from '@/assets/sidebar/Outline/Cancel.svg'
import Notifications from '@/components/Notifications/Notifications'
import FloatingChat from './FloatingChat.vue'

export default {
  name: 'Header',
  components: { Notifications, FloatingChat },
  data() {
    return {
      avatarImage,
      Menu,
      Exchange,
      Cross,
      Search,
      CaretDown,
      Settings,
      User,
      Document,
      Envelope,
      Cancel,
      dropdown: false,
      user: JSON.parse(localStorage.getItem('userPengendalian') || {}),
    }
  },
  computed: {
    ...mapState('layout', [
      'sidebarClose',
      'sidebarStatic',
      'navbarType',
      'navbarColorScheme',
    ]),
    firstUserLetter() {
      return (this.user.name || this.user.email || 'P')[0].toUpperCase()
    },
    navbarTypeClass: function () {
      return 'navbar-' + this.navbarType + '-type'
    },
  },
  methods: {
    ...mapActions('layout', [
      'toggleSidebar',
      'switchSidebar',
      'changeSidebarActive',
    ]),
    ...mapActions('auth', ['logoutUser']),
    switchSidebarMethod() {
      if (!this.sidebarClose) {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      } else {
        this.switchSidebar(false)
        const paths = this.$route.fullPath.split('/')
        paths.pop()
        this.changeSidebarActive(paths.join('/'))
      }
    },
    toggleSidebarMethod() {
      if (this.sidebarStatic) {
        this.toggleSidebar()
        this.changeSidebarActive(null)
      } else {
        this.toggleSidebar()
        const paths = this.$route.fullPath.split('/')
        paths.pop()
        this.changeSidebarActive(paths.join('/'))
      }
    },
  },
}
</script>

<style src="./Header.scss" lang="scss"></style>
